// Imports
import * as React from 'react';
import * as classNames from 'classnames';
import { computed, observable } from 'mobx';
import { observer } from 'mobx-react';

// Styles
const s = require('./FileUploadForm.css');

// Props
interface IFileUploadFormProps {
    onChange?: (files: FileList) => void;
    className?: string;
    label: string;
    disabled?: boolean;
    multiple?: boolean;
    acceptedExtensions?: string;
}

// State
interface IFileUploadFormState {
    label: string;
    isFormActive: boolean;
}

// Component
@observer
export class FileUploadForm extends React.Component<IFileUploadFormProps, IFileUploadFormState> {
    static get defaultProps(): IFileUploadFormProps {
        return {
            onChange: null,
            className: null,
            label: null,
            disabled: false,
            multiple: false,
            acceptedExtensions: null
        };
    }

    @observable private files: FileList = null;

    @computed
    private get hasFiles(): boolean {
        return this.files !== null && typeof this.files.length !== 'undefined' && this.files.length > 0;
    }

    @computed
    private get fieldLabel(): string {
        let label: string = '';

        if (this.hasFiles) {
            label += `Upload file${this.props.multiple ? 's' : ''}: `;

            // Iterate files
            for (let i = 0; i < this.files.length; i++) {
                const file = this.files[i];
                label += `${i > 0 ? ', ' : ''}${file.name}`;
            }
        } else {
            label = `Drag file${this.props.multiple ? 's' : ''} inside borders or click to upload attachment${
                this.props.multiple ? 's' : ''
            }`;
            label += this.props.multiple ? '. Use Shift or Ctrl to select few files.' : '';
        }

        return label;
    }

    private fileForm: HTMLDivElement = null;
    private fieldGroup: HTMLDivElement = null;
    private fileField: HTMLInputElement = null;
    private referenceFileForm = ref => (this.fileForm = ref);
    private referenceFieldGroup = ref => (this.fieldGroup = ref);
    private referenceFileField = ref => (this.fileField = ref);

    public render() {
        return (
            <div ref={this.referenceFileForm} className={classNames(s.form, this.props.className)}>
                {this.props.label && <h1 className={s.headline}>{this.props.label}</h1>}

                <div
                    ref={this.referenceFieldGroup}
                    className={classNames(s.fieldGroup, {
                        disabled: this.props.disabled,
                        active: this.hasFiles
                    })}
                >
                    <label>
                        <p>{this.fieldLabel}</p>

                        <input
                            type="file"
                            ref={this.referenceFileField}
                            defaultValue=""
                            disabled={this.props.disabled}
                            multiple={this.props.multiple}
                            accept={this.props.acceptedExtensions}
                            onDragLeave={e => this.handleDragLeave(e)}
                            onDragEnd={e => this.handleDragLeave(e)}
                            onDragEnter={e => this.handleDragEnter(e)}
                            onClick={e => this.handleClick(e)}
                            onChange={e => this.handleChange(e)}
                        />
                    </label>
                </div>
            </div>
        );
    }

    private handleDragEnter = (e: React.DragEvent<HTMLInputElement>) => {
        this.fileField.value = '';
        this.fieldGroup.classList.add('drag');
    };

    private handleDragLeave = (e: React.DragEvent<HTMLInputElement>) => {
        this.fieldGroup.classList.remove('drag');
    };

    private handleClick = (e: React.MouseEvent<HTMLInputElement>) => {
        this.fileField.value = '';
    };

    private handleChange = (e: React.FormEvent<HTMLInputElement>) => {
        this.files = this.fileField && this.fileField.files ? this.fileField.files : null;

        if (this.fileField && this.props.onChange) {
            this.props.onChange(this.fileField.files);
        }
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/forms/FileUploadForm.tsx